export default __webpack_public_path__ + "static/108170-917c646dc631231f6c5a7857646b7a90.jpg";